<template>
  <div>
    <SearchComponent
      :selectOrInputList="selectOrInputList"
      @on-search="handleSearch"
      @on-reset="handleReset"
      :authIdentity="authIdentity"
      @remoteMethod="supplierRemoteMethod"
    ></SearchComponent>
    <TablePublic
      :colLists="colLists"
      :tableData="tableData"
      :total="total"
      :pageParams="queryParams"
      @pageChange="getList"
    >
      <template slot="freightAmount" slot-scope="scope">
        <div>
          <template v-if="hasEditPerm">
            <span
              v-if="!scope.data.freightAmount"
              style="color: blue; cursor: pointer"
              @click="onOperat('supply', scope.data)"
              >补充运费</span
            >
            <span v-else style="cursor: pointer" @click="onOperat('supply', scope.data)">
              {{ ThousandAndDecimal(scope.data.freightAmount) }}
              <i style="color: blue;" class="el-icon-edit" @click="onOperat('supply', scope.data)"></i>
            </span>
          </template>
          <template v-else>
            {{ ThousandAndDecimal(scope.data.freightAmount || '-') }}
          </template>
        </div>
      </template>
      <template slot="status" slot-scope="scope">
        <el-tag :type="getStatusColor(scope.data)">{{ getStatusText(scope.data) }}</el-tag>
      </template>
      <template slot="solts" slot-scope="scope">
        <el-button
          v-hasPermi="[authIdentity + ':detail']"
          class="button"
          type="text"
          size="small"
          @click="onOperat('preview', scope.data)"
          >详情</el-button
        >
        <el-button
          @click="handlePrint(scope.data, scope.$index)"
          type="text"
          size="small"
          class="button"
          v-hasPermi="[authIdentity + ':print']"
          >打印</el-button
        >
        <!-- <el-dropdown style="margin-left:10px">
            <i class="el-icon-more"></i>
            <el-dropdown-menu>
              <el-dropdown-item
                v-for="(dropdown, index) in operateMore"
                :disabled="fundisabled(dropdown, scope.data)"
                @click.native="dropdown.click(scope.data)"
                :key="index"
                :icon="'el-icon-ht-'+dropdown.auth"
              >{{ dropdown.label }}</el-dropdown-item>
            </el-dropdown-menu>
        </el-dropdown>-->
      </template>
    </TablePublic>

    <!-- 弹窗区域 -->
    <Mdialog
      :title="operatDialog.title"
      :visible.sync="operatDialog.visible"
      :width="operatDialog.width"
      :close-on-click-modal="false"
      :append-to-body="true"
      :destroy-on-close="true"
      @closes="cancel"
    >
      <component
        :ref="operatDialog.currentView"
        :is="operatDialog.currentView"
        :data="operatDialog.data"
        :type="operatDialog.type"
      ></component>
      <span slot="footer" v-if="operatDialog.currentView !== 'MForm'">
        <el-button class="batch-button" @click="cancel">取 消</el-button>
        <el-button class="line-button" @click="submitFrom" :loading="submitLoading">确 定</el-button>
      </span>
    </Mdialog>

    <el-dialog
      title="打印预览"
      class="dialog"
      :visible.sync="printInfo.printDialog"
      :close-on-click-modal="false"
      width="60%"
      @close="printInfo.printDialog = false"
      destroy-on-close
      append-to-body
      :top="'5vh'"
    >
      <PrintBox ref="printBox" v-if="printInfo.printDialog" />
    </el-dialog>
  </div>
</template>

<script>
import SearchComponent from '@/components/searchComponent'
import Mdialog from '@/components/Mdialog'
import PrintBox from '@/components/PrintBox'
import TablePublic from '@/components/tablePublic'
import MForm from '@/views/pick/transport/components/form'
import Supply from './components/Supply.vue'

import { getSupplierList } from '@/api/manage/supplier'
import { getTransList, getTrans, updateFreightAmount } from '@/api/manage/shipping-order'
import { getDropPlantationList } from '@/api/manage/plantation'
import { getSelectPlantationArea } from '@/api/system/manage'

import {toUniqueStr} from '@/utils/common'

export default {
  name: 'Transport',
  components: {
    TablePublic,
    SearchComponent,
    Mdialog,
    MForm,
    Supply,
    PrintBox,
  },
  data() {
    const _this = this
    const title = '鲜果运输'
    return {
      authIdentity: 'pick:transport',
      dialogVisible: false,
      title: '',
      currentView: '',
      // operatDialog: {
      //   visible: false, //是否展示
      //   title: '', //弹窗标题
      //   currentView: null, //当前组件
      //   width: '', //弹窗宽度
      //   type: '', //提交类型
      //   data: {}, //弹窗数据
      // },
      colLists: [
        {
          prop: 'bizNo',
          label: '运输单号',
          isTrue: true,
          width: 150,
        },
        {
          prop: 'supplierName',

          label: '供应商名称',
          isTrue: true,
          width: 100,
        },
        {
          prop: 'licensePlateNumber',
          label: '车牌号',
          isTrue: true,
          width: 100,
        },
        {
          prop: 'freightAmount',
          label: '运输费用(元)',
          isTrue: true,
          width: 110,
          formSolt: true,
          // formatter(row) {
          //   return _this.ThousandAndDecimal(row.freightAmount)
          // },
        },
        {
          prop: 'lockNumber',
          label: '锁号',
          isTrue: true,
          width: '100',
        },
        {
          prop: '',
          label: '采摘批次',
          isTrue: true,
          width: 150,
          align: 'left',
          formatter(row) {
            return row.pickingBatchBizNoList?.join(',')
          },
        },
        {
          prop: '',
          label: '采摘日期',
          isTrue: true,
          width: '100',
          formatter(row) {
            return row.pickingDateTimeList?.map((item) => _this.parseTime(item, '{y}-{m}-{d}')).join(',')
          },
        },
        {
          prop: '',
          label: '果园名称',
          isTrue: true,
          width: 130,
          align: 'left',
          formatter(row) {
            return row.plantationNameList?.join(',')
          },
        },
        {
          prop: '',
          label: '果园区域',
          isTrue: true,
          align: 'left',
          formatter(row) {
            return row.locDetailsList?.map(item => item.split(',').slice(3).join('')).join(',')
          },
        },
        {
          prop: '',
          label: '加工厂地址',
          isTrue: true,
          width: 150,
          align: 'left',
          formatter(row) {
            let processFactoryAddress = []
            for(let i in row.processFactoryAddressList){
              let processFactory = row.processFactoryAddressList[i]
              if(processFactory){
                processFactoryAddress.push(toUniqueStr(processFactory))
              }
            }
            return processFactoryAddress.join(',')
          },
        },
        {
          prop: 'shipTotalQuantity',
          label: '满筐总筐数',
          isTrue: true,
        },
        {
          prop: 'shipTotalNetWeight',
          label: '总净重(斤)',
          isTrue: true,
          width: 100,
        },
        {
          prop: '',
          label: '监园人员',
          isTrue: true,
          formatter(row) {
            return [...new Set(row.supervisorIdList
              ?.map((item) => {
                return JSON.parse(item || '[]')
                  .map((s) => s.userName)
                  .join(',')
              }) || [])]
              .join(',')
          },
        },
        {
          prop: 'traceabilityNodeTime',
          label: '运输日期',
          isTrue: true,
          width: '100',
          formatter(row) {
            return row.traceabilityNodeTime ? _this.parseTime(row.traceabilityNodeTime, '{y}-{m}-{d}') : ''
          },
        },
        {
          prop: 'status',
          label: '状态',
          isTrue: true,
          formSolt: true,
          // formatter(row) {
          //   return row.status === 1 ? '未验收' : row.status === 2 ? '已验收' : ''
          // },
        },
        {
          label: '操作',
          prop: 'address',
          align: 'center',
          solt: true,
          isTrue: true,
          width: 200,
          rightFlag: true,
        },
      ],
      total: 0,
      tableData: [],
      selectOrInputList: [
        {
          model: 'supplierId',
          placeholder: '请选择供应商名称',
          value: 'id',
          label: 'name',
          list: [],
          type: 'select',
          remote: true,
        },
        {
          model: 'plantationId',
          placeholder: '请选择果园',
          value: 'id',
          label: 'name',
          list: [],
          type: 'select',
        },
        {
          model: 'licensePlateNumber',
          placeholder: '请输入车牌号',
          class: 'home',
          type: 'input',
        },
        {
          model: 'code',
          placeholder: '运输/采摘批次编号',
          class: 'home',
          type: 'input',
        },
        {
          model: 'locIndex',
          placeholder: '请选择果园区域',
          label: 'locName',
          value: 'locIndex',
          list: [],
          type: 'select',
        },
        {
          model: 'geoPosDetails',
          placeholder: '请输入加工厂地址',
          class: 'home',
          type: 'input',
        },
      ],

      // 弹窗数据
      operatDialog: {
        visible: false, // 是否展示
        title: '', // 弹窗标题
        currentView: null, //当前组件
        width: '', // 弹窗宽度
        type: '', // 提交类型
        data: {}, // 数据
      },

      // 弹窗枚举
      operatEnum: {
        add: () => {
          return {
            component: 'MForm',
            title: `新增${title}`,
            width: '75%',
          }
        },
        edit: () => {
          return {
            component: 'MForm',
            title: `修改${title}`,
            width: '75%',
          }
        },
        preview: () => {
          return {
            component: 'MForm',
            title: `查看${title}`,
            width: '60%',
          }
        },
        resubmit: () => {
          return {
            component: 'MFrom',
            title: `重新提交${title}`,
            width: '75%',
          }
        },
        submit: () => {
          return {
            component: 'Preview',
            title: `提交${title}`,
            width: '75%',
          }
        },
        supply: () => {
          return {
            component: 'Supply',
            title: `设置运费费用`,
            width: '30%',
          }
        },
      },
      submitLoading: false,

      queryParams: {
        pageNo: 1,
        pageSize: 10,
      },

      printInfo: {
        printDialog: false,
        type: 'transport',
        list: [],
      },
    }
  },
  computed: {
    hasEditPerm() {
      const pcPerms = JSON.parse(sessionStorage.getItem('pcPerms'))
      return pcPerms.includes(`${this.authIdentity}:edit`)
    },
  },
  mounted() {
    this.getSupplierList()
    this.getPlantationList()
    this.getSelectPlantationAreaList()
    this.getList()
  },
  methods: {
    getList(pageData) {
      if (pageData) {
        this.queryParams = Object.assign(this.queryParams, pageData)
      }
      getTransList(this.queryParams)
        .then((res) => {
          if (res.flag) {
            this.tableData = res.data.items.map((item) => {
              // item.visible = false
              // item.locName = this.formatLocal(item.locDetails, 3)
              // item.visitedDate = this.parseTime(item.visitedDateTime, '{y}-{m}-{d}')
              // item.statusText = CONSTANTS.getStatusConversion(item.status, 'taskStatus')
              // item.readyForHarvest = CONSTANTS.getStatusConversion(item.readyForHarvestStatus, 'readyForHarvestStatus')
              return item
            })
            this.total = res.data.totalCount
          }
        })
        .catch((error) => {
          console.log(error, 1)
        })
    },
    async getSelectPlantationAreaList() {
      let res = await getSelectPlantationArea()
      if (res.flag) {
        this.localList = res.data
        this.selectOrInputList[4].list = res.data.map((item, index) => {
          item.locIndex = index + 1
          item.locName = this.formatLocal(item.locDetails, 3)
          return item
        })
      }
    },
    async getSupplierList(queryParams = {}) {
      const data = await getSupplierList({
        pageNo: 1,
        pageSize: 30,
        name: queryParams.name,
      })
      if (data.code === 200 && data.flag) {
        this.selectOrInputList[0].list = data.data.items
      }
    },
    supplierRemoteMethod(val, item) {
      if (item.model === 'supplierId') {
        this.getSupplierList({ name: val })
      }
    },
    getPlantationList() {
      getDropPlantationList().then((res) => {
        this.selectOrInputList[1].list = res.data.map((item) => {
          item.name = `${item.bizNo}-${item.name}`
          return item
        })
      })
    },
    getStatusColor(row) {
      return row.status === 1 ? 'info' : row.status === 2 ? 'success' : 'info'
    },
    getStatusText(row) {
      return row.status === 1 ? '未验收' : row.status === 2 ? '已验收' : ''
    },
    // 操作: add添加，edit编辑，import导入, export导出, print打印
    onOperat(type, row) {
      // 添加操作类型
      const { component, title, width } = this.operatEnum[type]()
      this.operatDialog.title = title
      this.operatDialog.width = width
      this.operatDialog.type = type
      this.operatDialog.data = row || {}
      this.operatDialog.currentView = component
      this.operatDialog.visible = true
    },
    handleSee() {
      this.dialogVisible = true
    },
    handleUpdata() {
      this.dialogVisible = true
    },
    async handlePrint(row) {
      const data = await getTrans(row.id)
      if (!data.flag || data.code !== 200) {
        this.$message.error(data.msg)
        return
      }

      this.printInfo.list = [data.data]
      this.printInfo.printDialog = true
      this.$nextTick(() => {
        this.$refs.printBox.init(this.printInfo)
      })
    },
    handleDel() {},
    async submitFrom() {
      this.submitLoading = true

      try {
        const { id, freightAmount } = await this.$refs[this.operatDialog.currentView].submit()
        const data = await updateFreightAmount({ id, freightAmount })
        if (data.code === 200) {
          this.$message.success('修改成功')
          this.operatDialog.visible = false
          this.getList()
        }
      } finally {
        this.submitLoading = false
      }
    },
    cancel() {
      this.operatDialog.visible = false
    },
    add() {
      this.dialogVisible = true
      this.$nextTick(() => {
        this.title = '新增采购计划'
        this.currentView = 'MForm'
        this.type = 'add'
      })
    },
    handleSearch(query) {
      const locEnums = ['streetCode','villageCode','fieldCode']
      if (query.locIndex) {
        locEnums.forEach(d=>{
          query[d] = this.localList[query.locIndex - 1][d]
        })
      } else {
        locEnums.forEach(d=>{
          delete query[d]
          delete this.queryParams[d]
        })
      }
      this.queryParams.pageNo = 1
      this.queryParams = Object.assign(this.queryParams, query)
      this.getList()
    },
    handleReset() {
      this.queryParams = {
        pageNo: 1,
      }
      this.getList()
    },
  },
}
</script>
<style scoped lang="less">
@import '~@/assets/tableList.less';
// @import '../../../../assets/form.less';
</style>
